import api from '../config/axios-conf';

export const getCustomers = (params) =>
    api.get('/customers/customerAll', { params });

export const searchCustomers = (params) =>
    api.get('/customers/search', { params });

export const getCustomer = (id) =>
    api.get(`/customers/${id}`);

export const getCustomerByPhone = (phone) =>
    api.get(`/customers/phone/${phone}`);

export const createCustomer = (data) =>
    api.post('/customers/create', data);

export const updateCustomer = (id, data) =>
    api.put(`/customers/${id}`, data);

export const deleteCustomer = (id) =>
    api.delete(`/customers/${id}`);

export const getCustomerBills = (id, params) =>
    api.get(`/customers/${id}/bills`, { params });

export const getCustomerStatistics = (id) =>
    api.get(`/customers/${id}/statistics`);


export const getPointHistory = (id, params) =>
    api.get(`/points/history/${id}`, { params });

export const checkinCustomer = (data) =>
    api.post('/customers/checkin', data);

export const cancelCheckin = (id) =>
    api.delete(`/customers/checkin/${id}`);

export const getCheckinAll = () =>
    api.get('/customers/checkinAll');
